import { css } from "@emotion/react";
import { clamp } from "lodash-es";
import { useEffect, useRef, useState } from "react";
import { ProgressBar } from "reshaped";

type CountdownProgressProps = {
    from: Date;
    to: Date;
    onComplete?: () => void;
};

function remainingRatio(createdAt: Date, expiresAt: Date, now: number) {
    const total = expiresAt.getTime() - createdAt.getTime();
    if (total <= 0) return 0;
    const ellapsed = now - createdAt.getTime();
    const ratio = clamp(ellapsed / total, 0, 1);
    return ratio;
}

export default function CountdownProgress(props: CountdownProgressProps) {
    const { from, to, onComplete } = props;
    const [value, setValue] = useState(() => remainingRatio(from, to, Date.now()));
    const completedRef = useRef(false);

    useEffect(() => {
        const interval = window.setInterval(() => {
            setValue(remainingRatio(from, to, Date.now()));
        }, 1000);
        return () => window.clearInterval(interval);
    }, [from, to]);

    useEffect(() => {
        if (completedRef.current) return;
        if (value === 1) {
            completedRef.current = true;
            if (onComplete) onComplete();
        }
    }, [value, onComplete]);

    return (
        <div css={css({ width: "100%" })}>
            <ProgressBar min={0} max={1} value={value} />
        </div>
    );
}
